// LIST OF EVENTS
export const STUDENT_UPDATE = 'StudentUpdateEvent';
export const STUDENT_PRESENCE = 'StudentPresenceEvent';
export const STUDENT_BOOK_UPDATE = 'StudentBookUpdateEvent';

export const BOOK = {
  name: 'BookUpdateEvent',
  action: {
    BOOK_ADD: 'BOOK:ADD',
    BOOK_DELETE: 'BOOK:DELETE',
    BOOK_EDIT: 'BOOK:EDIT',
    BOOK_VISIBILITY: 'BOOK:VISIBILITY',
    BOOK_UNLINKED: 'BOOK:UNLINKED',
    BOOK_GET: 'BOOK:GET',
    ACTIVITY_ADD: 'ACTIVITY:ADD',
    ACTIVITY_DELETE: 'ACTIVITY:DELETE',
    ACTIVITY_EDIT: 'ACTIVITY:EDIT',
    ACTIVITY_GET: 'ACTIVITY:GET'
  }
};

export const DISCUSSIONS = {
  UPDATED: 'DISCUSSION_UPDATED',
  CREATED: 'DISCUSSION_CREATED',
  DELETED: 'DISCUSSION_DELETED',
  MESSAGES: {
    UPDATED: 'MESSAGE_UPDATED',
    CREATED: 'MESSAGE_CREATED'
  }
};

export const USER_GROUP = {
  name: 'user:group',
  action: {
    ASSIGN_STUDENT_TO_BOOK: 'USER_GROUP:ASSIGN_STUDENT_TO_BOOK',
    UNASSIGN_STUDENT_TO_BOOK: 'USER_GROUP:UNASSIGN_STUDENT_TO_BOOK'
  }
};

export const CLASSROOM = {
  name: 'classroom',
  action: {
    ARCHIVE: 'CLASSROOM:ARCHIVE'
  }
};

export const TASK = {
  name: 'task',
  action: {
    CREATED: 'TASK:CREATED',
    DELETED: 'TASK:DELETED',
    UPDATED: 'TASK:EDITED',
    ANSWER_UPDATED: 'TASK:ANSWER:UPDATED',
    GRADE_UPDATED: 'TASK:GRADE:UPDATED'
  }
};

export const STUDENT = {
  name: 'student',
  action: {
    ENROLLMENT: 'STUDENT:ENROLLMENT',
    UNENROLLMENT: 'STUDENT:UNENROLLMENT'
  }
};

export const TEACHER = {
  name: 'teacher',
  action: {
    ENROLLMENT: 'INSTRUCTOR:ENROLLMENT',
    UNENROLLMENT: 'INSTRUCTOR:UNENROLLMENT'
  }
};

export const VIDEOCALL = {
  name: 'videocall',
  action: {
    STARTED: 'VIDEOCALL:STARTED'
  }
};

export const GOOGLE = {
  name: 'google',
  action: {
    COURSEWORK_FINISHED: 'coursework-finished'
  }
};
